!function (e, n) {
  "object" == typeof exports && "undefined" != typeof module ? n(exports, require("react")) : "function" == typeof define && define.amd ? define(["exports", "react"], n) : n((e = e || self).useReducerAsync = {}, e.react);
}(this, function (e, n) {
  var u = "undefined" != typeof window ? n.useLayoutEffect : n.useEffect;

  e.useReducerAsync = function (e, t, r, c) {
    var f = c || r,
        o = n.useReducer(e, t, c && r),
        i = o[0],
        s = o[1],
        a = n.useRef(i);
    u(function () {
      a.current = i;
    }, [i]);
    var d = n.useCallback(function () {
      return a.current;
    }, []),
        l = n.useCallback(function (e) {
      var n = (e || {}).type,
          u = n && f[n] || null;
      u ? u(s, d)(e) : s(e);
    }, [f, d]);
    return [i, l];
  };
});